import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import { QuotePage } from '@sp/client/modules/quote';

import store, { history } from './store';
import PrivateRoute from './components/PrivateRouter';
import Layout from './components/Layout';
import NotFound from './components/NotFound';
import Login from './containers/Login';
import ForgotInfo from './containers/ForgotPassword/ForgotInfo';
import ForgotSave from './containers/ForgotPassword/ForgotSave';
import ProviderHome from './containers/Provider';
import ProviderNewPlan from './containers/ProviderNewPlan';
import ProviderPlanDetails from './containers/ProviderPlanDetails';
import ProviderPlans from './containers/ProviderPlans';
import ProviderBookings from './containers/ProviderBookings';
import ProviderBooking from './containers/ProviderBooking';
import ProviderManageBooking from './containers/ProviderManageBooking';
import ProviderDetails from './containers/ProviderDetails';
import ProviderClaim from './containers/ProviderClaim';
import CustomerPlans from './containers/CustomerPlans';
import CustomerDocs from './containers/CustomerDocs';
import CustomerDetails from './containers/CustomerDetails';
import CustomerBook from './containers/CustomerBook';
import CustomerPayments from './containers/CustomerPayments';
import CustomerPlanPayments from './containers/CustomerPlanPayments';
import AdminHomepage from './containers/AdminHomepage';
import AdminSuperLogin from './containers/AdminSuperLogin';
import AdminClaim from './containers/AdminClaim';

import { AdminPlanDetails, AdminPlans } from './modules/admin/containers';

import DB_CONST from './config/db_const';
import './index.less';

const target = document.querySelector('#root');

const { PROVIDER, CUSTOMER, ADMIN } = DB_CONST.USER_ROLES;

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Layout>
        <Switch>
          <Redirect exact from="/" to="/login" />
          <Route exact path="/login" component={Login} />
          <Route exact path="/forgot-password" component={ForgotInfo} />
          <Route
            exact
            path="/forgot-password-save/:token"
            component={ForgotSave}
          />
          <PrivateRoute
            exact
            path="/provider"
            component={ProviderHome}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/new-plan"
            component={ProviderNewPlan}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/new-plan-submit/:id"
            component={QuotePage}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/plans/:searchValue?"
            component={ProviderPlans}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/bookings"
            component={ProviderBookings}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/bookings/:id"
            component={ProviderManageBooking}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/bookings/create/:id"
            component={ProviderBooking}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/my-details"
            component={ProviderDetails}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/plans/view/:id"
            component={ProviderPlanDetails}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/provider/claim/:id"
            component={ProviderClaim}
            allowRole={PROVIDER}
          />
          <PrivateRoute
            exact
            path="/customer/plans"
            component={CustomerPlans}
            allowRole={CUSTOMER}
          />
          <PrivateRoute
            exact
            path="/customer/docs"
            component={CustomerDocs}
            allowRole={CUSTOMER}
          />
          <PrivateRoute
            exact
            path="/customer/my-details"
            component={CustomerDetails}
            allowRole={CUSTOMER}
          />
          <PrivateRoute
            exact
            path="/customer/plans/:id"
            component={CustomerBook}
            allowRole={CUSTOMER}
          />
          <PrivateRoute
            exact
            path="/customer/payments"
            component={CustomerPayments}
            allowRole={CUSTOMER}
          />
          <PrivateRoute
            exact
            path="/customer/payments/:id"
            component={CustomerPlanPayments}
            allowRole={CUSTOMER}
          />
          {/* Admin Panel */}
          <PrivateRoute
            exact
            path="/admin"
            component={AdminHomepage}
            allowRole={ADMIN}
          />
          <PrivateRoute
            exact
            path="/admin/plans"
            component={AdminPlans}
            allowRole={ADMIN}
          />
          <PrivateRoute
            exact
            path="/admin/plans/:id"
            component={AdminPlanDetails}
            allowRole={ADMIN}
          />
          <PrivateRoute
            exact
            path="/admin/superlogin"
            component={AdminSuperLogin}
            allowRole={ADMIN}
          />
          <PrivateRoute
            exact
            path="/admin/claim"
            component={AdminClaim}
            allowRole={ADMIN}
          />
          <Route component={NotFound} />
        </Switch>
      </Layout>
    </ConnectedRouter>
  </Provider>,
  target,
);
